function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#zfklwo1ota)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M79.698 87.412c-11.602-7.456-20.563-16.539-25.686-25.164-5.148-8.669-6.308-16.654-2.791-22.125 3.516-5.472 11.261-7.734 21.285-6.652 9.974 1.077 21.959 5.455 33.561 12.911 11.602 7.456 20.562 16.54 25.685 25.165 5.149 8.668 6.308 16.653 2.792 22.125-3.517 5.471-11.261 7.734-21.286 6.651-9.974-1.077-21.958-5.454-33.56-12.91zm-32.541-14.78c8.81 2.98 20.087 8.56 31.73 16.042 11.642 7.483 21.403 15.424 27.774 22.199 3.189 3.392 5.499 6.461 6.78 9.009 1.307 2.6 1.424 4.41.718 5.509-.707 1.099-2.402 1.744-5.31 1.636-2.85-.107-6.6-.933-11.011-2.425-8.81-2.981-20.088-8.561-31.73-16.043-11.643-7.483-21.404-15.423-27.774-22.199-3.19-3.392-5.5-6.46-6.78-9.009-1.307-2.6-1.424-4.41-.718-5.509.706-1.099 2.401-1.744 5.31-1.635 2.849.106 6.6.933 11.01 2.425zm12.156 46.5c-11.661-7.494-21.827-14.863-28.835-20.712-3.508-2.929-6.203-5.458-7.897-7.42-.85-.985-1.42-1.794-1.72-2.413-.326-.674-.222-.879-.218-.885.004-.006.148-.186.896-.169.688.016 1.66.197 2.91.562 2.488.726 5.908 2.126 10.029 4.1 8.232 3.945 19.158 10.132 30.819 17.626 11.66 7.494 21.827 14.862 28.835 20.712 3.508 2.928 6.202 5.458 7.896 7.42.851.985 1.419 1.793 1.72 2.413.326.673.222.879.218.885-.004.006-.147.186-.896.169-.688-.016-1.659-.197-2.909-.562-2.488-.726-5.908-2.126-10.03-4.101-8.232-3.944-19.157-10.131-30.818-17.625z",
  stroke: "#4E5EFA",
  strokeWidth: 1.5
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "zfklwo1ota"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "rotate(122.728 65.2 77.712)",
  d: "M0 0h120v120H0z"
})));

function SvgFigure3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure3);
export default __webpack_public_path__ + "static/media/figure-3.1ac3cb36.svg";
export { ForwardRef as ReactComponent };